import { useQuery } from "@tanstack/react-query";
import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

// const service = registerService('user-meta');
// export default service;

const endpoint:string = 'user-meta';

export function useGetAllUserMeta() {
    return useGetAll({queryKey: [endpoint]});
}

export function useGetUserMeta(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateUserMeta() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateUserMeta({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteUserMeta({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
